module.exports = __webpack_public_path__ + "static/tyrant01-a0718caccc13442ab5e2383be7d10c72.png";